<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid full-width>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label="Seleziona un operaio"
                        title="Operaio" :auto-filter="true"
                        value=""
                        :options="operai"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <h6 style="margin-top:1rem;">Numero Ore di Lavoro</h6>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida"/>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida"/>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label="Seleziona un cliente" title="Cliente"
                        :auto-filter="true"
                        v-model="modello_clienti"
                        :options="clienti"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-checkbox label="Solo non dimessi"
                       :value="v_non_dimessi"
                       :checked="flg_non_dimessi" />
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-checkbox label="Includi lista lavori svolti"
                       :value="v_lista"
                       :checked="flg_lista" />
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaOperai",
  components: { BottonieraRicerche },
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: ""
      },
      v_non_dimessi: "1",
      flg_non_dimessi: true,
      v_lista: "1",
      flg_lista: true,
      modello_clienti: "",
      operai: [
        {
          value: "1",
          label: "Mario Rossi",
          name: "1"
        },
        {
          value: "2",
          label: "Paolo Bianchi",
          name: "2"
        },
        {
          value: "3",
          label: "Sergio Verdi",
          name: "3"
        }
      ],
      clienti: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "1"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "2"
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>